<template>
  <v-btn v-bind="$attrs" :color="color" :density="density" :icon="icon" :variant="variant" />
</template>

<script setup lang="ts">
export interface Props {
  color?: string
  density?: 'comfortable' | 'compact'
  icon?: boolean | string
  variant?: 'flat' | 'outlined' | 'text'
}

withDefaults(defineProps<Props>(), {
  color: 'interactive',
  density: 'comfortable',
  icon: true,
  variant: 'text',
})
</script>
